import { Flag } from './Flag';

export function Flags(flags) {
  return Object.keys(flags).reduce((acc, flag) => {
    acc[flag] = Flag(flag, flags[flag]);
    return acc;
  }, {});
}
